import React from 'react';

import { Confirmation } from 'components/Confirmation/Confirmation';
import { Heading } from 'components/Heading/Heading';
import { Modal } from 'components/ui/Modal/Modal';
import { useTranslations } from 'utils';
import { createMarkup } from 'utils/createMarkup/createMarkup';

type PrefillModalProps = {
  body: string;
  isOpen?: boolean;
  onClose: () => void;
  onConfirm: () => void;
  onReject: () => void;
  title: string;
};

const PrefillModal = ({
  body,
  isOpen = false,
  onClose,
  onConfirm,
  onReject,
  title,
}: PrefillModalProps) => {
  const i18n = useTranslations();

  return (
    <Modal size="medium" isOpen={isOpen} onClose={onClose}>
      <Heading as="h3" size="large">
        {title}
      </Heading>
      <p
        className="type-regular"
        dangerouslySetInnerHTML={createMarkup(body)}
      />
      <Confirmation
        confirmationButtonText={i18n.t('senderInformation.confirmButtonText')}
        rejectionButtonText={i18n.t('senderInformation.rejectButtonText')}
        onConfirm={onConfirm}
        onReject={onReject}
      />
    </Modal>
  );
};

PrefillModal.displayName = 'PrefillModal';

export { PrefillModal };
